/**
 * Subscribes to the global `versionmismatch` event dispatched by the API
 * client. Returns the server's full version string once a mismatch is
 * observed; until then, returns `null`.
 *
 * Major mismatches are sticky — once seen, we never clear; the user must
 * refresh.
 */

import { useEffect, useState } from 'react';
import { VERSION_MISMATCH_EVENT, type VersionMismatchDetail } from '../api/client';

export function useApiVersionGuard(): string | null {
  const [mismatch, setMismatch] = useState<string | null>(null);
  useEffect(() => {
    function onEvent(e: Event) {
      const detail = (e as CustomEvent<VersionMismatchDetail>).detail;
      setMismatch(detail.serverFull);
    }
    window.addEventListener(VERSION_MISMATCH_EVENT, onEvent);
    return () => window.removeEventListener(VERSION_MISMATCH_EVENT, onEvent);
  }, []);
  return mismatch;
}
